<template>
    <v-form ref="form" :disabled="disabled">
        <v-row>
            <v-col cols="12">
                <span>
                    <span class="text-h6 text-capitalize">
                        {{ `${$t(`transfers.${pointType === 'departure' ? 'from' : 'to'}`)}: ` }}
                    </span>
                    <v-icon class="me-2">mdi-map-marker</v-icon>
                    <div class="text-h6 text--secondary" v-html="locationName" />
                </span>
            </v-col>
        </v-row>
    </v-form>
</template>

<script lang="ts">
    import {Component, mixins, Prop} from 'vue-facing-decorator'
    import {TransferFormMixin} from '@/components/transfers/mixins/TransferFormMixin.vue'

    @Component({})
    export class TransferPositionForm extends mixins(TransferFormMixin) {
        @Prop({required: true}) pointType
        @Prop({default: false, type: Boolean}) disabled

        hotel = null

        mounted() {
            this.change({
                prop: this.pointType,
                val: {
                    type: this.point.type,
                    address: this.point.title,
                    postalCode: this.point.postalCode,
                },
            })
        }

        get locationName() {
            return this.point.title
        }
    }

    export default TransferPositionForm
</script>
